exports.versionInfo = {
    version:  VERSION,
    revision: COMMITHASH,
    date:     DATE,
    deploy:   DEPLOY,
    build:    BUILD,
    server:   RELEASESERVER
};
